import gql from "graphql-tag";

export const MY_TIME_MESSAGES_SUBSCRIPTION = gql`
  subscription myTimeMessagesSubscription {
    myTimeMessagesSubscription
  }
`;
